// Toggle-Chips für die ILO-Verknüpfung von TLAs/ATs — ersetzt die
// Display-only-Anzeige. Generisch über dem Key-Typ K: Wizard = Array-Index
// (schreibt linked_ilo_indices im lokalen State), Editor = UUID (speichert
// über die bestehenden PATCH-Endpoints via updateTLA/updateAT).
export default function LinkedILOsEditor<K extends string | number>({
  label,
  ilos,
  selected,
  onToggle,
  emptyHint,
  disabled = false,
}: {
  label: string;
  ilos: { key: K; label: string; title?: string }[];
  selected: K[];
  onToggle: (key: K) => void;
  emptyHint?: string;
  disabled?: boolean;
}) {
  if (ilos.length === 0) return null;
  return (
    <div className="mt-1">
      <span className="block text-xs font-black uppercase text-ca-surface-muted tracking-widest mb-1.5">
        {label}:
      </span>
      <div className="flex flex-wrap items-center gap-2">
        {ilos.map((ilo) => {
          const active = selected.includes(ilo.key);
          return (
            <button
              key={ilo.key}
              type="button"
              disabled={disabled}
              onClick={() => onToggle(ilo.key)}
              title={ilo.title}
              aria-pressed={active}
              className={`px-2.5 py-1 rounded-md border text-xs font-semibold transition disabled:opacity-40 ${
                active
                  ? "bg-ca-accent text-ca-brand border-ca-accent"
                  : "bg-ca-card text-ca-surface-muted border-ca-surface-border hover:border-ca-accent hover:text-ca-surface-ink"
              }`}
            >
              {ilo.label}
            </button>
          );
        })}
        {selected.length === 0 && emptyHint && (
          <span className="text-xs text-ca-surface-muted italic">{emptyHint}</span>
        )}
      </div>
      {/* Volltext der verlinkten Lernziele unter den Chips — die Kurz-Labels
          („LZ 1") allein sagen nicht, welches Lernziel gemeint ist. */}
      {selected.length > 0 && (
        <ul className="mt-2 space-y-1">
          {ilos
            .filter((ilo) => selected.includes(ilo.key))
            .map((ilo) => (
              <li key={ilo.key} className="text-xs text-ca-surface-muted leading-snug">
                <span className="font-bold text-ca-surface-accent mr-1.5">{ilo.label}</span>
                {ilo.title}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}
